import React, { useEffect, useState } from "react";

const SIZES = [85, 100, 115, 130, 145];

function applyFontSize(scale) {
  const elements = document.body.querySelectorAll("*");

  elements.forEach((element) => {
    // Boshqaruv tugmalarining o'lchami o'zgarmasin
    if (element.closest(".font-size-controls")) return;

    const styles = window.getComputedStyle(element);

    // Dastlabki shrift o'lchamini faqat bir marta saqlaymiz
    if (!element.dataset.fontBaseSize) {
      element.dataset.fontBaseSize = parseFloat(styles.fontSize);
    }

    const baseSize = Number(element.dataset.fontBaseSize);

    if (Number.isFinite(baseSize)) {
      element.style.setProperty(
        "font-size",
        `${baseSize * scale}px`,
        "important"
      );
    }

    // Matn kattalashganda qatorlar ustma-ust tushmasin
    if (!element.dataset.fontBaseLineHeight) {
      element.dataset.fontBaseLineHeight = styles.lineHeight;
    }

    const baseLineHeight = element.dataset.fontBaseLineHeight;

    if (baseLineHeight.endsWith("px")) {
      const lineHeight = parseFloat(baseLineHeight);

      if (Number.isFinite(lineHeight)) {
        element.style.setProperty(
          "line-height",
          `${lineHeight * scale}px`,
          "important"
        );
      }
    }
  });
}

export default function FontSizeControls() {
  const [size, setSize] = useState(() => {
    const saved = Number(localStorage.getItem("site-font-size"));
    return SIZES.includes(saved) ? saved : 100;
  });

  useEffect(() => {
    const scale = size / 100;

    applyFontSize(scale);
    localStorage.setItem("site-font-size", String(size));

    // React orqali keyinroq qo'shilgan elementlarga ham tatbiq etish
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== Node.ELEMENT_NODE) return;

          if (node.matches(".font-size-controls")) return;

          const applyToNode = (element) => {
            if (element.closest(".font-size-controls")) return;

            const styles = window.getComputedStyle(element);

            if (!element.dataset.fontBaseSize) {
              element.dataset.fontBaseSize =
                parseFloat(styles.fontSize);
            }

            const base = Number(element.dataset.fontBaseSize);

            if (Number.isFinite(base)) {
              element.style.setProperty(
                "font-size",
                `${base * scale}px`,
                "important"
              );
            }

            if (!element.dataset.fontBaseLineHeight) {
              element.dataset.fontBaseLineHeight = styles.lineHeight;
            }

            const lineHeight = element.dataset.fontBaseLineHeight;

            if (lineHeight.endsWith("px")) {
              element.style.setProperty(
                "line-height",
                `${parseFloat(lineHeight) * scale}px`,
                "important"
              );
            }
          };

          applyToNode(node);
          node.querySelectorAll("*").forEach(applyToNode);
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => observer.disconnect();
  }, [size]);

  const changeSize = (direction) => {
    const index = SIZES.indexOf(size);
    const nextIndex = Math.max(
      0,
      Math.min(SIZES.length - 1, index + direction)
    );

    setSize(SIZES[nextIndex]);
  };

  return (
    <div className="font-size-controls" aria-label="Shrift o‘lchami">
      <button
        type="button"
        onClick={() => changeSize(-1)}
        disabled={size === SIZES[0]}
        aria-label="Shriftni kichraytirish"
        title="Kichraytirish"
      >
        A−
      </button>

      <button
        type="button"
        onClick={() => setSize(100)}
        className={size === 100 ? "font-size-active" : ""}
        aria-label="Standart shrift"
        title="Standart o‘lcham"
      >
        A
      </button>

      <button
        type="button"
        onClick={() => changeSize(1)}
        disabled={size === SIZES[SIZES.length - 1]}
        aria-label="Shriftni kattalashtirish"
        title="Kattalashtirish"
      >
        A+
      </button>

      <span className="font-size-value">{size}%</span>
    </div>
  );
}